import { useSelector } from "react-redux";
import { RootState } from "store";

export const useGetAgencyTimezone = () => {
    const { selectedAgency } = useSelector((state: RootState) => state.auth);
    return selectedAgency?.timezone;
};

export const useGetAgencyGSTRequired = () => {
    const { selectedAgency } = useSelector((state: RootState) => state.auth);
    return selectedAgency?.gst_required;
};

export const useGetPartnerLogo = () => {
    const { master } = useSelector((state: RootState) => state.auth);
    return master?.partner?.logo_url;
}

export const useGetPartnerMenuStyle = () => {
    const { master } = useSelector((state: RootState) => state.auth);
    return master?.partner?.menu_style;
}